import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PlayerProvider } from './lib/PlayerContext';
import { AuthProvider } from './context/AuthContext';
import { AccessibilityProvider } from './context/AccessibilityContext';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/ui/Toast';
import { Layout } from './components/Layout';
import AuthRequiredModal from './components/auth/AuthRequiredModal';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Artist } from './pages/Artist';
import { Voicebank } from './pages/Voicebank';
import { Song } from './pages/Song';
import { Album } from './pages/Album';
import { Albums } from './pages/Albums';
import { About } from './pages/About';
import { Help } from './pages/Help';
import { ForArtists } from './pages/ForArtists';
import Changelog from './pages/Changelog';
import Profile from './pages/Profile';
import Library from './pages/Library';
import PublicProfile from './pages/PublicProfile';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { NotFound } from './pages/NotFound';
import { UIShowcase } from './pages/UIShowcase';
import { Analytics } from './pages/Analytics';

function App() {
  return (
    <ErrorBoundary>
      <AccessibilityProvider>
        <ToastProvider>
          <Router future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}>
            <AuthProvider>
              <PlayerProvider>
              <Routes>
                {/* Legal pages without layout */}
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                
                {/* Regular pages with layout */}
                <Route path="/*" element={
                  <Layout>
                    <AuthRequiredModal />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/search" element={<Search />} />
                      <Route path="/artist/:id" element={<Artist />} />
                      <Route path="/voicebank/:id" element={<Voicebank />} />
                      <Route path="/song/:id" element={<Song />} />
                      <Route path="/album/:id" element={<Album />} />
                      <Route path="/albums" element={<Albums />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/subscription" element={<Subscription />} />
                      <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                      <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
                      <Route path="/library" element={<Library />} />
                      <Route path="/analytics" element={<Analytics />} />
                      <Route path="/user/:id" element={<PublicProfile />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/help" element={<Help />} />
                      <Route path="/forartists" element={<ForArtists />} />
                      <Route path="/changelog" element={<Changelog />} />
                      <Route path="/ui-showcase" element={<UIShowcase />} />
                      {/* Catch-all route for unknown paths */}
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Layout>
                } />
              </Routes>
            </PlayerProvider>
          </AuthProvider>
        </Router>
      </ToastProvider>
    </AccessibilityProvider>
    </ErrorBoundary>
  );
}

export default App;
